import { render, staticRenderFns } from "./TopToolbarDesktop.vue?vue&type=template&id=6f5bec0c"
import script from "./TopToolbarDesktop.vue?vue&type=script&lang=js"
export * from "./TopToolbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./TopToolbarDesktop.vue?vue&type=style&index=0&id=6f5bec0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports